export default __webpack_public_path__ + "static/media/uni-logo.e88f150a.png";